<div class="n-oldalfej">
  <div>
    <h2>Cégautóadó</h2>
    <span class="n-alcim">{{ aktiv.ugyfelNev || 'nincs kiválasztott cég' }} · Gjt. 17/A–17/G. § · {{ ev }}</span>
  </div>
  <div class="spacer"></div>
  <label class="ca-valaszto" *ngIf="ful !== 'adotetelek' && ful !== 'konyveles'">
    <select [ngModel]="negyedev" (ngModelChange)="negyedevValt(+$event)" title="Negyedév">
      <option *ngFor="let n of negyedevek" [ngValue]="n">{{ romai[n] }} negyedév</option>
    </select>
  </label>
  <ion-button *ngIf="ful === 'szamfejtes'" (click)="szamol()" [disabled]="!aktiv.ugyfelId || fut">
    <ion-icon slot="start" name="calculator-outline"></ion-icon>{{ adat?.sorok?.length ? 'Újraszámolás' : 'Számfejtés' }}</ion-button>
  <ion-button *ngIf="ful === 'lista'" (click)="nyomtat()" [disabled]="!lista"><ion-icon slot="start" name="print-outline"></ion-icon>Nyomtatás</ion-button>
  <ion-button *ngIf="ful === 'bevallas'" (click)="bevallasNyitVagyUj()" [disabled]="!lap || fut"
              [title]="'A negyedév ' + kod + '-es bevallása a nyomtatványkitöltőben – a számfejtésből előtöltve, NAV-ellenőrzéssel és beküldéssel'">
    <ion-icon slot="start" name="paper-plane-outline"></ion-icon>{{ fut ? 'Előkészítés…' : 'Bevallás (' + kod + ')' }}</ion-button>
</div>

<div class="n-fulek">
  <button *ngFor="let f of fulek" type="button" [class.aktiv]="ful === f.k" (click)="fulValt(f.k)">{{ f.c }}</button>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz céget a fejlécben.</div>
<p class="gj-figyelem ca-margo" *ngIf="hiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ hiba }}</p>

<ng-container *ngIf="aktiv.ugyfelId">

  <!-- ══════════ SZÁMFEJTÉS ══════════ -->
  <ng-container *ngIf="ful === 'szamfejtes'">
    <div class="n-szuro-sor">
      <label>Időszak
        <select [ngModel]="nezet" (ngModelChange)="nezetValt($event)"><option value="negyedev">negyedév</option><option value="ho">hónap</option></select></label>
      <label *ngIf="nezet === 'ho'">Hónap
        <select [ngModel]="ho" (ngModelChange)="hoValt(+$event)"><option *ngFor="let h of honapok" [ngValue]="h.v">{{ h.c }}</option></select></label>
      <label class="ca-pipa"><input type="checkbox" [(ngModel)]="csakAdokoteles"> csak az adóköteles tételek</label>
      <span class="cimke sarga" *ngIf="adat?.ugyfel?.atalanyado || adat?.ugyfel?.kata">Átalányadózó / KATA-s – cégautóadót nem fizet (nincs tételes költségelszámolás)</span>
      <span class="cimke sarga" *ngIf="vanElavult">A számfejtés óta módosult a járműtörzs vagy az adótétel – számold újra</span>
      <span class="cimke" *ngIf="adat && szamfejtetlen.length">Számfejtetlen: {{ szamfejtetlen.join(', ') }}. hó</span>
      <span class="cimke sarga" *ngIf="param && !param.ellenorzott" [title]="param.forras || ''">A(z) {{ ev }}. évi adótétel ellenőrizendő</span>
      <span class="cimke petrol" *ngIf="vanFeladott">a Könyvelésbe feladva</span>
      <span class="spacer"></span>
      <button type="button" class="ov-gomb halvany-gomb" (click)="torol()" [disabled]="!adat?.sorok?.length"><ion-icon name="trash-outline"></ion-icon>Számfejtés törlése</button>
    </div>

    <div class="ata-kpi" *ngIf="adat?.sorok?.length">
      <div class="n-panel ata-k"><span>Számított adó</span><b>{{ adat.osszesen.ado | number:'1.0-0' }} Ft</b><small>{{ idoszakNev }} · {{ autokSzama }} adóköteles autó</small></div>
      <div class="n-panel ata-k"><span>Levonható gépjárműadó</span><b>{{ adat.osszesen.levonas | number:'1.0-0' }} Ft</b><small>Gjt. 17/F. §</small></div>
      <div class="n-panel ata-k ata-teher"><span>Fizetendő cégautóadó</span><b>{{ adat.osszesen.fizetendo | number:'1.0-0' }} Ft</b>
        <small>bevallás és befizetés: a negyedévet követő hónap 20-áig (241-es adónem)</small></div>
    </div>

    <div class="tabla-wrap" *ngIf="sorok.length">
      <table class="n-racs">
        <thead><tr>
          <th *ngIf="nezet === 'negyedev'">Hónap</th><th>Rendszám</th><th class="num">kW</th><th>Osztály</th><th>Tétel</th>
          <th class="num">Hányad</th><th class="num">Tarifa</th><th class="num">Számított</th><th class="num">Levonás</th>
          <th class="num">Adó</th><th class="num">Fizetendő</th><th>Megjegyzés</th><th></th>
        </tr></thead>
        <tbody>
          <tr *ngFor="let s of sorok" [class.ca-nemkoteles]="!s.adokoteles && !s.kezi">
            <td *ngIf="nezet === 'negyedev'">{{ honapNev(s.ho) }}</td>
            <td><b class="ca-rendszam">{{ s.rendszam }}</b><span class="halvany" *ngIf="s.gyartmany"> {{ s.gyartmany }} {{ s.tipus }}</span></td>
            <td class="num">{{ s.teljesitmeny_kw }}</td>
            <td>{{ s.korny_osztaly }}</td>
            <td class="ca-kicsi">{{ param?.sav_nevek?.[s.kw_sav - 1] }} kW × {{ csoportNev[s.osztaly_csoport] }}</td>
            <td class="num">{{ s.tulajdoni_hanyad < 100 ? (s.tulajdoni_hanyad + '%') : '' }}</td>
            <td class="num">{{ s.adokoteles ? (s.tarifa | number:'1.0-0') : '' }}</td>
            <td class="num">{{ s.adokoteles ? (s.szamitott_ado | number:'1.0-0') : '–' }}</td>
            <td class="num">{{ s.levonas ? (s.levonas | number:'1.0-0') : '' }}</td>
            <td class="num"><b>{{ s.ado | number:'1.0-0' }}</b></td>
            <td class="num"><b>{{ s.fizetendo | number:'1.0-0' }}</b></td>
            <td class="ca-megj">
              <span class="cimke petrol" *ngIf="s.kezi" [title]="(s.kezi_ki || '') + ' ' + (s.kezi_mikor || '')">kézi: {{ s.kezi_indok }}</span>
              <span class="cimke sarga" *ngIf="s.elavult">elavult</span>
              <span class="cimke" *ngIf="s.auto_torolve">törölt jármű</span>
              <span class="halvany">{{ s.indok }}</span>
            </td>
            <td class="ca-muv"><button type="button" class="kv-mini" (click)="keziNyit(s)" title="Kézi felülírás"><ion-icon name="create-outline"></ion-icon></button></td>
          </tr>
        </tbody>
        <tfoot><tr>
          <td [attr.colspan]="nezet === 'negyedev' ? 7 : 6">Összesen</td>
          <td class="num">{{ adat.osszesen.szamitott_ado | number:'1.0-0' }}</td><td class="num">{{ adat.osszesen.levonas | number:'1.0-0' }}</td>
          <td class="num">{{ adat.osszesen.ado | number:'1.0-0' }}</td><td class="num">{{ adat.osszesen.fizetendo | number:'1.0-0' }}</td><td></td><td></td>
        </tr></tfoot>
      </table>
    </div>
    <div class="ures" *ngIf="adat && !adat.sorok?.length">
      <ion-icon name="car-outline"></ion-icon>A(z) {{ idoszakNev }} még nincs számfejtve (vagy nem volt használatban cégautó).
      <ng-container *ngIf="!adat.jarmu_db"><br>A cégnek még nincs aktív személygépkocsija –
        <button type="button" class="ov-link" (click)="jarmuvekre()">vedd fel a Járművek között</button> (a cégautóadó adatai a jármű „Cégautóadó” részén).</ng-container>
    </div>

    <div class="n-panel ata-info">
      <div class="n-panel-cim">Hogyan számol</div>
      <ul>
        <li><b>Adótétel</b> = kW-sáv × környezetvédelmi osztálycsoport („0”–„4” / „6”–„10” / „5”; „14–15”) az év adótételei szerint (Gjt. 17/E. §), közös tulajdonnál a tulajdoni hányaddal. Csak a személygépkocsi tárgya az adónak.</li>
        <li><b>Hónapok</b>: {{ param?.honap_szabaly === 'barmely_nap' ? 'a használat bármely napja a teljes havi adót viszi (egyszerűsített beállítás).' : 'a kötelezettség a szerzést / lízingbe vételt / első költségelszámolást KÖVETŐ hónap 1. napján kezdődik, és az eladás / visszaadás / utolsó költségelszámolás hónapjának végéig tart (Gjt. 17/C. §). Törtidőszakra nem osztható.' }}</li>
        <li><b>Nem adóköteles</b>: 5E / 5Z környezetkímélő gépkocsi; a 2025 előtt nyilvántartásba vett 5P / 5N 2026. 12. 31-ig (Gjt. 19/D. §); a Gjt. 17/D. § szerinti mentes autó; ha nem a cég az adó alanya (operatív lízing, bérlet); átalányadózó / KATA-s egyéni vállalkozó.</li>
        <li><b>Levonás</b>: a cég által határidőben megfizetett gépjárműadó havi része (az éves 1/12-e), legfeljebb a havi adó (Gjt. 17/F. §).</li>
        <li>Az eredmény <b>tárolódik</b>: a lista, a 2601-es bevallás és a Könyvelés-feladás ebből dolgozik. Újraszámoláskor a kézzel felülírt tételek megmaradnak.</li>
      </ul>
    </div>
  </ng-container>

  <!-- ══════════ LISTA ══════════ -->
  <ng-container *ngIf="ful === 'lista'">
    <div class="n-szuro-sor">
      <label>Nézet
        <select [ngModel]="listaNezet" (ngModelChange)="listaNezetValt($event)">
          <option value="negyedev">negyedév</option><option value="ho">hónap</option><option value="ev">egész év</option></select></label>
      <label *ngIf="listaNezet === 'ho'">Hónap
        <select [ngModel]="ho" (ngModelChange)="ho = +$event; listaBetolt()"><option *ngFor="let h of honapok" [ngValue]="h.v">{{ h.c }}</option></select></label>
      <span class="cimke sarga" *ngIf="lista?.nincs_szamfejtve?.length && listaNezet !== 'ev'">Nincs számfejtve: {{ lista.nincs_szamfejtve.join(', ') }}. hó</span>
      <span class="cimke sarga" *ngIf="listaElavult">A számfejtés óta módosult a járműtörzs vagy az adótétel – a lista a tárolt állapotot mutatja</span>
    </div>

    <ng-container *ngIf="lista">
      <div class="tabla-wrap" *ngIf="listaNezet === 'ho' && lista.sorok.length">
        <table class="n-racs">
          <thead><tr>
            <th>Rendszám</th><th>Gyártmány, típus</th><th>Tulajdonviszony</th><th class="num">kW</th><th>Osztály</th><th class="num">Hányad</th>
            <th class="num">Tarifa</th><th class="num">Adó</th><th class="num">Levonás</th><th class="num">Fizetendő</th><th>Megjegyzés</th>
          </tr></thead>
          <tbody>
            <tr *ngFor="let s of lista.sorok" [class.ca-nemkoteles]="!s.adokoteles && !s.kezi">
              <td><b class="ca-rendszam">{{ s.rendszam }}</b></td>
              <td>{{ s.gyartmany }} {{ s.tipus }}<span class="halvany" *ngIf="s.auto_torolve">(törölt jármű)</span></td>
              <td>{{ tulajdonviszonyNev(s.tulajdonviszony) }}</td>
              <td class="num">{{ s.teljesitmeny_kw }}</td>
              <td>{{ s.korny_osztaly }}</td>
              <td class="num">{{ s.tulajdoni_hanyad < 100 ? s.tulajdoni_hanyad + '%' : '' }}</td>
              <td class="num">{{ s.adokoteles ? (s.tarifa | number:'1.0-0') : '' }}</td>
              <td class="num">{{ s.ado | number:'1.0-0' }}</td>
              <td class="num">{{ s.levonas ? (s.levonas | number:'1.0-0') : '' }}</td>
              <td class="num"><b>{{ s.fizetendo | number:'1.0-0' }}</b></td>
              <td class="ca-megj"><span class="cimke petrol" *ngIf="s.kezi">kézi: {{ s.kezi_indok }}</span> <span class="halvany">{{ s.indok }}</span></td>
            </tr>
          </tbody>
          <tfoot><tr>
            <td colspan="7">Összesen ({{ lista.sorok.length }} autó)</td>
            <td class="num">{{ lista.osszesen.ado | number:'1.0-0' }}</td><td class="num">{{ lista.osszesen.levonas | number:'1.0-0' }}</td>
            <td class="num">{{ lista.osszesen.fizetendo | number:'1.0-0' }}</td><td></td>
          </tr></tfoot>
        </table>
      </div>

      <div class="tabla-wrap" *ngIf="listaNezet !== 'ho' && lista.autok.length">
        <table class="n-racs">
          <thead><tr>
            <th>Rendszám</th><th>Gyártmány, típus</th><th class="num">kW</th><th>Osztály</th>
            <th class="num" *ngFor="let h of lista.honapok">{{ listaNezet === 'ev' ? h + '.' : honapNev(h) }}</th>
            <th class="num">Adó</th><th class="num">Levonás</th><th class="num">Fizetendő</th><th></th>
          </tr></thead>
          <tbody>
            <tr *ngFor="let a of lista.autok" [class.ca-nemkoteles]="!a.ado">
              <td><b class="ca-rendszam">{{ a.rendszam }}</b></td>
              <td>{{ a.gyartmany }} {{ a.tipus }}</td>
              <td class="num">{{ a.teljesitmeny_kw }}</td>
              <td>{{ a.korny_osztaly }}</td>
              <td class="num" *ngFor="let h of lista.honapok" [title]="a.honapok[h]?.indok || ''">{{ hoAdo(a, h) == null ? '' : (hoAdo(a, h) | number:'1.0-0') }}</td>
              <td class="num">{{ a.ado | number:'1.0-0' }}</td>
              <td class="num">{{ a.levonas ? (a.levonas | number:'1.0-0') : '' }}</td>
              <td class="num"><b>{{ a.fizetendo | number:'1.0-0' }}</b></td>
              <td><span class="cimke petrol" *ngIf="a.kezi">kézi</span><span class="cimke sarga" *ngIf="a.elavult">elavult</span></td>
            </tr>
          </tbody>
          <tfoot><tr>
            <td colspan="4">Összesen</td>
            <td class="num" *ngFor="let h of lista.honapok">{{ lista.honap_osszesen[h]?.ado | number:'1.0-0' }}</td>
            <td class="num">{{ lista.osszesen.ado | number:'1.0-0' }}</td><td class="num">{{ lista.osszesen.levonas | number:'1.0-0' }}</td>
            <td class="num">{{ lista.osszesen.fizetendo | number:'1.0-0' }}</td><td></td>
          </tr></tfoot>
        </table>
      </div>
      <div class="ures" *ngIf="!lista.sorok.length"><ion-icon name="list-outline"></ion-icon>A(z) {{ listaIdoszakNev }} nincs számfejtett cégautóadó.</div>
    </ng-container>
  </ng-container>

  <!-- ══════════ ADÓTÉTELEK ══════════ -->
  <ng-container *ngIf="ful === 'adotetelek' && param">
    <div class="n-panel ca-param">
      <div class="ca-param-fej">
        <span class="n-panel-cim">Adótételek – {{ ev }} (Ft / hó / autó)</span>
        <span class="cimke" [class.zold]="param.ellenorzott" [class.sarga]="!param.ellenorzott">{{ param.ellenorzott ? 'NAV-forrással ellenőrzött' : 'ellenőrizendő' }}</span>
        <span class="cimke" *ngIf="!param.mentve" title="Az első számfejtés vagy mentés rögzíti">javasolt, még nincs mentve</span>
        <span class="halvany ca-kicsi">{{ param.forras }}</span>
      </div>
      <p class="halvany ca-sugo">Az intézmény minden cégére érvényes; az évet a fejléc évválasztója adja.
        <ng-container *ngIf="param.modositotta"> Utoljára módosította: {{ param.modositotta }}, {{ param.modositva }}.</ng-container></p>
      <table class="n-racs ca-param-racs">
        <thead><tr><th>Teljesítmény (kW)</th><th class="num" *ngFor="let c of csoportok">{{ csoportNev[c] }}</th></tr></thead>
        <tbody>
          <tr *ngFor="let s of savok">
            <td>{{ param.sav_nevek?.[s - 1] }}</td>
            <td class="num" *ngFor="let c of csoportok"><input type="number" min="0" [(ngModel)]="param['s' + s + '_' + c]" [disabled]="!param.irhato"></td>
          </tr>
        </tbody>
      </table>
      <div class="ca-param-mezok">
        <label class="kv-mezo"><span>kW-sávhatárok</span>
          <span class="kv-egyutt"><input type="number" [(ngModel)]="param.kw_hatar1" [disabled]="!param.irhato"><input type="number" [(ngModel)]="param.kw_hatar2" [disabled]="!param.irhato"><input type="number" [(ngModel)]="param.kw_hatar3" [disabled]="!param.irhato"></span></label>
        <label class="kv-mezo"><span>Hónap-szabály</span>
          <select [(ngModel)]="param.honap_szabaly" [disabled]="!param.irhato"><option *ngFor="let h of honapSzabalyok" [ngValue]="h.v">{{ h.c }}</option></select></label>
        <label class="kv-mezo"><span>5P/5N mentes, ha nyilv. vétel előtte</span><input type="date" [(ngModel)]="param.phev_nyilv_hatar" [disabled]="!param.irhato"></label>
        <label class="kv-mezo"><span>… eddig a napig</span><input type="date" [(ngModel)]="param.phev_mentes_ig" [disabled]="!param.irhato"></label>
        <label class="kv-mezo"><span>Forrás</span><input type="text" maxlength="255" [(ngModel)]="param.forras" [disabled]="!param.irhato"></label>
        <div class="ca-pipa"><label><input type="checkbox" [(ngModel)]="param.ellenorzott" [disabled]="!param.irhato"> NAV-forrással ellenőriztem</label></div>
      </div>
      <p class="halvany ca-sugo">A tételeket a NAV évente valorizálja, és az előző év október 31-ig közzéteszi (nav.gov.hu → Adókulcsok, járulékmértékek →
        Valorizált adómértékek → Cégautóadó). Egy új év az előző év tételeit örökli „ellenőrizendő” jelzéssel. Módosítás után a már számfejtett hónapokat számold újra.</p>
      <div class="ca-lab">
        <span class="halvany ca-kicsi" *ngIf="!param.irhato">Az adótételt a modul munkatársa (flottakezelő, könyvelő) módosíthatja.</span>
        <span class="spacer"></span>
        <button type="button" class="ov-gomb fo" (click)="paramMent()" [disabled]="paramMentes || !param.irhato"><ion-icon name="save-outline"></ion-icon>Adótételek mentése</button>
      </div>
    </div>
  </ng-container>

  <!-- ══════════ BEVALLÁS (2601) ══════════ -->
  <ng-container *ngIf="ful === 'bevallas' && lap">
    <div class="n-szuro-sor">
      <span class="cimke">Bevallás és befizetés határideje: {{ hatarido }}</span>
      <span class="cimke zold">{{ lap.autok_szama }} adóköteles autó</span>
      <span class="cimke sarga" *ngFor="let f of lap.figyelmeztetes">{{ f }}</span>
      <span class="spacer"></span>
      <label>Benyújtás (új bevallásnál)
        <select [(ngModel)]="mod"><option value="E">nem magánszemélyként (cég, egyéni vállalkozó)</option><option value="M">magánszemélyként</option></select></label>
      <button type="button" class="ov-gomb" (click)="munkalap('csv')" title="A lap képe, a mezőkódok és az autónkénti tételek – munkalap, nem beküldhető"><ion-icon name="document-outline"></ion-icon>CSV</button>
      <button type="button" class="ov-gomb" (click)="munkalap('xlsx')" title="Ugyanez Excel-munkafüzetként"><ion-icon name="grid-outline"></ion-icon>Excel</button>
    </div>

    <div class="n-panel">
      <div class="n-panel-cim">A cég {{ kod }}-es bevallásai ({{ ev }})</div>
      <div class="ca-negyedek">
        <div class="ca-negyed" *ngFor="let n of negyedevek" [class.aktiv]="n === negyedev">
          <div class="ca-negyed-fej"><b>{{ romai[n] }} negyedév</b>
            <button type="button" class="ov-link" *ngIf="n !== negyedev" (click)="negyedevValt(n)">lap megjelenítése</button></div>
          <div *ngFor="let b of negyedevBevallasai(n)" class="ca-bev" (click)="bevallasNyit(b)" [title]="b.cim || ''">
            <span class="cimke" [class.zold]="b.allapot === 'befogadva' || b.allapot === 'bekuldve'" [class.sarga]="b.allapot === 'hibas'">{{ allapotNev[b.allapot] || b.allapot }}</span>
            <span>{{ b.jelleg === 'H' ? 'helyesbítő' : b.jelleg === 'O' ? 'önellenőrző' : 'alap' }}</span>
            <span class="cimke petrol" *ngIf="b.modul !== 'GEPJARMU'" [title]="'A ' + modulCim(b.modul) + ' oldalán készült'">{{ modulCim(b.modul) }}</span>
            <span class="spacer"></span><ion-icon name="open-outline"></ion-icon>
          </div>
          <div class="halvany ca-kicsi" *ngIf="!negyedevBevallasai(n).length">Még nincs bevallás.</div>
          <button type="button" class="ov-gomb" (click)="bevallasUj(n)" [disabled]="fut"><ion-icon name="add-outline"></ion-icon>Új {{ kod }} (előtöltve)</button>
        </div>
      </div>
    </div>

    <div class="n-panel">
      <div class="n-panel-cim">{{ lap.nyomtatvany }}-02 · (B) blokk – a cégautóadó havonta ({{ romai[negyedev] }} negyedév)</div>
      <table class="n-racs">
        <thead><tr><th>Sor</th><th>Megnevezés</th>
          <th class="num" *ngFor="let h of lap.honapok; let i = index">{{ 'abc'[i] }}) {{ honapNev(h) }}</th><th class="num">d) Negyedév</th></tr></thead>
        <tbody>
          <tr *ngFor="let r of lap.sorok_01_03" [class.ca-fizetendo]="r.sor === 3">
            <td>{{ r.sor < 10 ? '0' + r.sor : r.sor }}.</td><td>{{ r.nev }}</td>
            <td class="num">{{ r.a | number:'1.0-0' }}</td><td class="num">{{ r.b | number:'1.0-0' }}</td>
            <td class="num">{{ r.c | number:'1.0-0' }}</td><td class="num"><b>{{ r.d | number:'1.0-0' }}</b></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="n-panel">
      <div class="n-panel-cim">(C) blokk – a személygépkocsik darabszáma (tájékoztató adat)</div>
      <div class="tabla-wrap ca-belso">
        <table class="n-racs ca-lap">
          <thead>
            <tr><th rowspan="2">Sor</th><th rowspan="2">Teljesítmény (kW)</th><th rowspan="2" class="num" title="Tulajdoni hányad alapján megosztás történt">a) megosztott</th>
              <th colspan="3" class="ca-cs">„0”–„4”</th><th colspan="3" class="ca-cs">„6”–„10”</th><th colspan="3" class="ca-cs">„5”; „14–15”</th></tr>
            <tr><th class="num">b) db</th><th class="num">c) Ft</th><th class="num" title="Hatósági nyilvántartásban nem szereplő">d) nem nyilv.</th>
              <th class="num">e) db</th><th class="num">f) Ft</th><th class="num">g) nem nyilv.</th>
              <th class="num">h) db</th><th class="num">i) Ft</th><th class="num">j) nem nyilv.</th></tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let h of [1, 2, 3]">
              <tr class="ca-honap-fej"><td colspan="12">A negyedév {{ h === 1 ? 'első' : h === 2 ? 'második' : 'harmadik' }} hónapja – {{ honapNev(lap.honapok[h - 1]) }}</td></tr>
              <tr *ngFor="let r of sorokHonap(h)" [class.ca-ures-sor]="!r.b && !r.e && !r.h">
                <td>{{ r.sor < 10 ? '0' + r.sor : r.sor }}.</td><td>{{ r.sav_nev }}</td><td class="num">{{ r.a || '' }}</td>
                <td class="num">{{ r.b || '' }}</td><td class="num">{{ r.c ? (r.c | number:'1.0-0') : '' }}</td><td class="num">{{ r.d || '' }}</td>
                <td class="num">{{ r.e || '' }}</td><td class="num">{{ r.f ? (r.f | number:'1.0-0') : '' }}</td><td class="num">{{ r.g || '' }}</td>
                <td class="num">{{ r.h || '' }}</td><td class="num">{{ r.i ? (r.i | number:'1.0-0') : '' }}</td><td class="num">{{ r.j || '' }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <div class="n-panel ata-info">
      <div class="n-panel-cim">Bevallás és beküldés</div>
      <ul>
        <li><b>Bevallás ({{ lap.nyomtatvany }})</b>: a negyedév bevallását a nyomtatványkitöltő nyitja meg, ebből a számfejtésből előtöltve
          (borítólap: adózó, időszak, „a cégautóadó bevallás benyújtása”; a 02-es lap 01–15. sora). Ott ellenőrizhető és javítható, a
          <b>NAV-ellenőrzés</b> beküldés nélkül megméri, a <b>Beküldés</b> gépi úton (M2M) adja be – a cég NAV-kapcsolatával (Könyvelés › Szervíz).
          Amíg a NAV a nyomtatványt gépi úton nem fogadja, a kitöltő jelzi; ilyenkor az onnan letöltött XML az <b>ONYA</b>-ban adható be.</li>
        <li>A Bérben 2026. október 18. előtt készült 2601-esek itt is látszanak és megnyithatók (a „Bér” címkéjűek).</li>
        <li><b>CSV / Excel</b>: a fenti lap képe, a NAV-mezőkódok és az autónkénti tételek – egyeztetéshez, <b>nem beküldhető állomány</b>.</li>
        <li>A 04–15. sor „c/f/i” oszlopát a NAV ellenőrzése a darabszámból is kiszámolja; kézzel módosított adónál (megosztás nélkül) ezért eltérést jelezhet.</li>
        <li>A 2601 más adónemeit (rehabilitációs hozzájárulás) ez a lap nem tölti; az ÁNYK 2026. december 31-én megszűnik, ÁNYK-állomány ezért nem készül.</li>
      </ul>
    </div>
  </ng-container>

  <!-- ══════════ KÖNYVELÉS (feladás) ══════════ -->
  <ng-container *ngIf="ful === 'konyveles' && feladas">
    <p class="gj-figyelem ca-margo" *ngIf="!feladas.feladhato"><ion-icon name="information-circle-outline"></ion-icon>{{ feladas.ok_szoveg }}</p>
    <p class="gj-figyelem ca-margo" *ngIf="feladas.feladhato && !feladas.konyvelhet"><ion-icon name="lock-closed-outline"></ion-icon>
      A Könyvelésbe a cég könyvelője ad fel (könyvelői jog kell a Könyvelésben) – itt csak az állapot látszik.</p>
    <p class="gj-figyelem ca-margo" *ngIf="feladas.ev_lezarva"><ion-icon name="lock-closed-outline"></ion-icon>
      A(z) {{ ev }}. év a Könyvelésben le van zárva (évzárás) – feladni és visszavonni már nem lehet.</p>

    <div class="n-panel" *ngIf="feladas.feladhato">
      <div class="n-panel-cim">Főkönyvi számlák (vegyes napló)</div>
      <div class="ca-szamlak">
        <label class="kv-mezo"><span>Tartozik – ráfordítás</span><input type="text" maxlength="12" [(ngModel)]="szamlak.raforditas" placeholder="8671"></label>
        <label class="kv-mezo"><span>Követel – kötelezettség</span><input type="text" maxlength="12" [(ngModel)]="szamlak.kotelezettseg" placeholder="4696"></label>
        <label class="ca-pipa"><input type="checkbox" [(ngModel)]="megjegyez"> a cég alapértelmezése legyen</label>
        <button type="button" class="ov-link" (click)="szamlaAlap()">alapértelmezés: {{ feladas.alap_szamlak.raforditas }} / {{ feladas.alap_szamlak.kotelezettseg }}</button>
      </div>
      <p class="halvany ca-sugo">A cégautóadó egyéb ráfordítás (8671 Költségvetéssel elszámolt adók és illetékek), a kötelezettség a Gjt. szerinti adók
        elszámolási számláján (4696 Gépjárműadó elszámolási számla) – mindkettő átírható. Egy negyedév = egy bizonylat, járművenként egy tételsorral,
        a negyedév utolsó napjával; a fizetendő (a 17/F. § szerinti levonás utáni) összeg kerül fel. A befizetést a bank napló könyveli.</p>
    </div>

    <div class="tabla-wrap">
      <table class="n-racs">
        <thead><tr><th>Negyedév</th><th class="num">Adó</th><th class="num">Levonás</th><th class="num">Fizetendő</th><th>Bizonylat</th><th>Feladva</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let n of feladas.negyedevek" [class.ca-nemkoteles]="!n.osszeg && !n.feladva">
            <td><b>{{ romai[n.negyedev] }} negyedév</b><span class="halvany" *ngIf="n.szamfejtett_honap < 3"> · {{ n.szamfejtett_honap }}/3 hónap számfejtve</span></td>
            <td class="num">{{ n.ado | number:'1.0-0' }}</td>
            <td class="num">{{ n.levonas ? (n.levonas | number:'1.0-0') : '' }}</td>
            <td class="num"><b>{{ n.osszeg | number:'1.0-0' }}</b></td>
            <td class="ca-kicsi">{{ n.bizonylatszam }} · {{ n.datum }}</td>
            <td class="ca-megj">
              <ng-container *ngIf="n.feladva">
                <span class="cimke zold">{{ n.feladva.osszeg | number:'1.0-0' }} Ft · {{ n.feladva.mikor }}</span>
                <span class="halvany"> {{ n.feladva.ki }}<ng-container *ngIf="n.feladva.sorszam"> · vegyes napló {{ n.feladva.sorszam }}. tétel</ng-container>
                  <ng-container *ngIf="n.feladva.szamlak"> · T {{ n.feladva.szamlak.raforditas }} / K {{ n.feladva.szamlak.kotelezettseg }}</ng-container></span>
                <span class="cimke sarga" *ngIf="n.elter">eltér a mostani számfejtéstől – add fel újra</span>
                <span class="cimke sarga" *ngIf="!n.feladva.tetel_megvan">a bizonylatot a Könyvelésben törölték</span>
              </ng-container>
              <span class="halvany" *ngIf="!n.feladva">–</span>
              <span class="cimke sarga" *ngIf="n.elavult">a számfejtés elavult – számold újra</span>
            </td>
            <td class="ca-muv">
              <button type="button" class="ov-gomb fo" *ngIf="feladhatoGomb && (n.osszeg || n.feladva)" (click)="felad(n)" [disabled]="fut">
                <ion-icon name="git-network-outline"></ion-icon>{{ n.feladva ? 'Újrafeladás' : 'Feladás' }}</button>
              <button type="button" class="ov-gomb halvany-gomb" *ngIf="n.feladva && feladas.konyvelhet && !feladas.ev_lezarva" (click)="visszavon(n)" [disabled]="fut">
                <ion-icon name="arrow-undo-outline"></ion-icon>Visszavonás</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</ng-container>

<ion-modal #keziModal cssClass="bevsor-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Kézi felülírás – {{ kezi?.s?.rendszam }}, {{ honapNev(kezi?.s?.ho) }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="keziModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="ca-form" *ngIf="kezi">
      <p class="halvany ca-sugo">Számított: adó {{ kezi.s.szamitott_ado | number:'1.0-0' }} Ft, levonás {{ kezi.s.gjt_levonas | number:'1.0-0' }} Ft
        <ng-container *ngIf="kezi.s.indok"> · {{ kezi.s.indok }}</ng-container></p>
      <label class="kv-mezo"><span>Adó (Ft) *</span><input type="number" min="0" [(ngModel)]="kezi.ado"></label>
      <label class="kv-mezo"><span>Levonás (Ft)</span><input type="number" min="0" [(ngModel)]="kezi.levonas" placeholder="üresen: a számított"></label>
      <label class="kv-mezo"><span>Indoklás *</span><input type="text" maxlength="255" [(ngModel)]="kezi.indok" placeholder="pl. NAV-határozat szerinti gépjárműadó"></label>
      <div class="ca-lab">
        <span class="spacer"></span>
        <button type="button" class="ov-gomb" *ngIf="kezi.s.kezi" (click)="keziTorol()"><ion-icon name="refresh-outline"></ion-icon>Vissza a számítotthoz</button>
        <button type="button" class="ov-gomb fo" (click)="keziMent()"><ion-icon name="save-outline"></ion-icon>Mentés</button>
      </div>
    </div>
  </ng-template>
</ion-modal>
